import * as React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

type LinkProps = Omit<RouterLinkProps, 'to'> & {
  href?: RouterLinkProps['to'];
  to?: RouterLinkProps['to'];
};

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, to, ...props }, ref) => <RouterLink ref={ref} to={to ?? href ?? '#'} {...props} />
);

Link.displayName = 'Link';

export default Link;
